const AppointmentViewFilters = {
  default: [
      {
    label: "Status",
    key: "appointmentStatus",
    options: ["Scheduled", "Rescheduled", "Cancelled", "Not-Attended","Completed" ],
  },

      {
  label: "Department",
  key: "department",
  options: [
    "General Physician",
    "Cardiologist",
    "Dermatologist",
    "Neurologist",
    "Orthopedic Surgeon",
    "Pediatrician",
    "Psychiatrist",
    "Gynecologist",
    "Oncologist",
    "ENT Specialist",
    "Ophthalmologist",
    "Dentist",
    "Radiologist",
    "Anesthesiologist",
    "Gastroenterologist",
    "Nephrologist",
    "Urologist",
    "Endocrinologist",
    "Pulmonologist",
    "Rheumatologist",
    "Hematologist",
    "Plastic Surgeon",
    "General Surgeon",
    "Neurosurgeon",
    "Cosmetologist",
    "Pathologist",
    "Sexologist",
    "Allergist/Immunologist",
    "Diabetologist",
    "Laparoscopic Surgeon",
    "Internal Medicine Specialist",
    "Homeopathic Doctor",
    "Ayurvedic Doctor",
    "Unani Practitioner",
    "Occupational Therapist",
    "Physiotherapist"
  ]
},

  ],
  additional: [
  {
      label: "Date",
      key: "appointmentDate",
      operator: "Between",
      inputType: "date-range",
    }
  ]
};

export default AppointmentViewFilters;